export enum SchemaType {
  CREATE = 'create',
  UPDATE = 'update',
  VIEW = 'view'
}
